import dayjs from 'dayjs';

const sortReviews = (reviews, sortBy) => {
  const sorted = [...reviews];
  switch (sortBy) {
    case 'newest':
      return sorted.sort((a, b) => dayjs(b.createdAt).valueOf() - dayjs(a.createdAt).valueOf());
    case 'oldest':
      return sorted.sort((a, b) => dayjs(a.createdAt).valueOf() - dayjs(b.createdAt).valueOf());
    case 'highest':
      return sorted.sort((a, b) => (b.rating || 0) - (a.rating || 0));
    case 'lowest':
      return sorted.sort((a, b) => (a.rating || 0) - (b.rating || 0));
    default:
      return sorted;
  }
};

export default sortReviews;
